// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.main-container {
  padding: 24px 32px;
  font-family: "Gotham", Arial, sans-serif;
}

.top-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.top-container #title {
  font-size: large;
  font-family: "GothamBold", Arial, sans-serif;
  margin: 0;
}
.top-container .close-btn {
  border: none;
  background: none;
  cursor: pointer;
  color: #707070;
}

.warning-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: #fff3e0;
  border-left: 4px solid #e5601f;
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 2px;
}
.warning-banner .warning-icon {
  font-size: 22px;
  height: 22px;
  width: 22px;
  color: #e5601f;
  flex-shrink: 0;
  margin-top: 2px;
}
.warning-banner .warning-text {
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  color: #4e342e;
}
.warning-banner .warning-text strong {
  display: block;
  margin-bottom: 4px;
  font-family: "GothamBold", Arial, sans-serif;
}
.warning-banner .warning-text p {
  margin: 0;
  line-height: 1.4;
}

.modal-content {
  display: flex;
  flex-direction: column;
}
.modal-content ::ng-deep .mat-form-field-outline {
  color: #e3e3e3;
}

.form-field {
  display: flex;
  flex-direction: column;
}
.form-field .field-label {
  font-size: 13px;
  color: #707070;
  font-family: "Gotham", Arial, sans-serif;
  margin-bottom: 4px;
}
.form-field .full-width {
  width: 100%;
}

.retire-error {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #e21836;
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  margin-top: 8px;
}
.retire-error .error-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: middle;
  flex-shrink: 0;
}

.progress-bar-container {
  margin: 8px 0;
}

.lower-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 16px;
}
.lower-container .btn-divider {
  width: 8px;
}
.lower-container .secondary {
  background: none;
  border: 1px solid #8c8f93;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  color: #707070;
}
.lower-container .secondary:hover:not(:disabled) {
  background-color: #e3e3e3;
}
.lower-container .secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.lower-container .retire-btn {
  display: inline-flex;
  align-items: center;
  background-color: #97002e;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
}
.lower-container .retire-btn:disabled {
  background-color: #8c8f93;
  cursor: not-allowed;
}
.lower-container .retire-btn:hover:not(:disabled) {
  background-color: rgb(100, 0, 30.4635761589);
}
.lower-container .retire-btn .inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
